module.exports = __webpack_public_path__ + "img/traffic-costs.81f3607a.svg";